import axios from 'axios';

const appApi = axios.create({
    baseURL: process.env.REACT_APP_API,
    timeout: 90000,
});

const apiVerify = axios.create({
    baseURL: process.env.REACT_APP_VERIFY,
    timeout: 90000,
})

export default { appApi, apiVerify };
